import { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Button, CircularProgress, TextField } from '@material-ui/core';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import AppContext from '../../../App/AppContext';
import { getCustomStyle, postCustomStyle } from '../../../Core/Service/admin-customStyle-service.js';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Custom Styles', active: true }
];

const CustomStyles = () => {
    const { showToast } = useContext(AppContext);
    const history = useHistory();
    const [state, setState] = useState({
        CustomStyles: '',
        loading: false,
        saving: false
    });

    useEffect(() => {
        const fetchCustomStyles = async () => {
            setState(prev => ({ ...prev, loading: true }));
            try {
                const response = await getCustomStyle();
                setState(prev => ({
                    ...prev,
                    CustomStyles: response.message || '',
                    loading: false
                }));
            } catch (error) {
                showToast('Error loading custom styles', 'error');
                setState(prev => ({ ...prev, loading: false }));
            }
        };

        fetchCustomStyles();
    }, []);

    const handleFieldChange = (event) => {
        setState(prev => ({ ...prev, CustomStyles: event.target.value }));
    };

    const handleSave = async () => {
        setState(prev => ({ ...prev, saving: true }));
        try {
            await postCustomStyle({ fileContent: state.CustomStyles });
            showToast('Custom styles saved successfully!', 'success');
            history.push('/');
        } catch (error) {
            showToast('Failed to save custom styles', 'error');
        } finally {
            setState(prev => ({ ...prev, saving: false }));
        }
    };

    return (
        <div style={{ 
            height: 'calc(100vh - 64px)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }}>
            <div style={{ 
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                padding: '0 16px',
                overflow: 'hidden'
            }}>
                <BreadCrumbs crumbs={crumbs} />
                <Typography variant="body2" color="secondary" style={{ 
                    textAlign: 'left',
                    margin: '8px 0'
                }}>
                    Custom Styles
                </Typography>
                <hr style={{ marginBottom: '16px' }} />

                {state.loading ? (
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        height: '100%'
                    }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '80%',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            flex: 1,
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <TextField
                                value={state.CustomStyles}
                                onChange={handleFieldChange}
                                placeholder="Add custom styles here"
                                multiline
                                fullWidth
                                variant="outlined"
                                rows={15}
                                style={{
                                    flex: 1,
                                    overflowY: 'auto',
                                    marginBottom: '8px'
                                }}
                                InputProps={{
                                    style: {
                                        height: '100%',
                                        alignItems: 'flex-start',
                                        overflow: 'auto'
                                    }
                                }}
                            />
                        </div>
                        <div style={{ 
                            textAlign: 'right',
                            padding: '8px 0',
                            position: 'sticky',
                            bottom: 0,
                            background: 'white'
                        }}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={handleSave} 
                                disabled={state.saving}
                                style={{ minWidth: '120px' }}
                            >
                                {state.saving ? <CircularProgress size={24} /> : 'Save'}
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomStyles;
